import React, { useMemo, useState } from "react";
import web5 from "../img/e1.jpg";
import h1 from "../img/h1.jpg";
import h2 from "../img/h2.jpg";
import h3 from "../img/h3.jpg";
import h4 from "../img/jwl1.jpg";
import h5 from "../img/h4.jpg";
import h6 from "../img/h5.jpg";
import h7 from "../img/h6.jpg";
import h8 from "../img/h7.jpg";
import h9 from "../img/h9.jpg";
import h10 from "../img/h10.jpg";
import h11 from "../img/h11.jpg";
import h12 from "../img/h12.jpg";
import h13 from "../img/retail.jpg";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../style/styles.css";
import "../style/Product.css";
import "../style/ProductInquiry.css";

const PRODUCTS = [
  {
    title: "SaleSync",
    subtitle: "Software for Retail OutLet",
    image: h13,
    path: "/Retails",
    category: "Retail",
    description:
      "Software for retail settings that uses touchscreen devices (such tablets, POS (Point of Sale) systems, or kiosks) to expedite different business operations is known as touchscreen-enabled retail outlet software. Usually, these technologies are employed to improve inventory control, sales transactions, client engagement, and other crucial retail business activities. Customers and staff can engage with the system more easily because to the more user-friendly and intuitive interface made possible by touchscreen technology.",
    seoText:
      "SaleSync is a retail POS software for retail outlets, supermarkets, grocery stores, garments shops, footwear shops, electronics stores, mobile shops and departmental stores with GST billing, inventory, purchase, stock and MIS reports.",
    keywords: [
      "SaleSync Retail Software",
      "Retail POS Software",
      "Retail Billing Software",
      "Retail Management Software",
      "Retail Outlet Software",
      "Retail Inventory Software",
      "GST Billing Software",
      "GST Retail Billing Software",
      "Touch Screen Billing Software",
      "Point of Sale Software",
      "POS Billing Software",
      "Barcode Billing Software",
      "Inventory Management Software",
      "Stock Management Software",
      "Purchase Billing Software",
      "Product Ledger Software",
      "Physical Stock Taking Software",
      "Minimum Stock Alert Software",
      "Dead Stock Management Software",
      "High Value Stock Tracking Software",
      "MIS Report Software",
      "Retail Accounting Software",
      "Supermarket Billing Software",
      "Grocery Store Billing Software",
      "Garments Store Billing Software",
      "Footwear Store Billing Software",
      "Electronics Store Billing Software",
      "Mobile Shop Billing Software",
      "Departmental Store Software",
      "General Store Billing Software",
      "Retail Software in India",
      "Retail Software in Siliguri",
      "Retail Software in West Bengal",
    ],
  },
  {
    title: "HotelSof",
    subtitle: "Software for Hotel, Resorts, Motels",
    image: h1,
    path: "/Hotelsof",
    category: "Hospitality",
    description:
      "HotelSof has been providing property management systems to hotels, motels, and resorts. It is a comprehensive software suite consisting of integrated modules for various aspects of hotel management. This class of software is often referred to as Property Management System in the industry. Our client base ranges from small elegant hotels to large full-service properties. By developing our own Room Reservations, Food & Beverage POS and complete Accounting.",
    seoText:
      "HotelSof is a hotel PMS software and restaurant POS solution for hotels, resorts, motels and hospitality businesses with room reservation, check-in, checkout, GST billing, KOT, QR menu, inventory, banquet, laundry and accounting.",
    keywords: [
      "HotelSof Hotel Software",
      "Hotel Management Software",
      "Hotel PMS Software",
      "Property Management System Software",
      "Hotel Property Management Software",
      "Hotel ERP Software",
      "Hotel Billing Software",
      "Hotel Front Office Software",
      "Hotel Reservation Software",
      "Room Booking Software",
      "Room Reservation Software",
      "Check-in Checkout Software",
      "Hotel Guest Management Software",
      "Guest Ledger Software",
      "Hotel Housekeeping Software",
      "Hotel Room Status Software",
      "Hotel Tariff Management Software",
      "Hotel Occupancy Report Software",
      "Night Audit Software for Hotels",
      "Hotel GST Billing Software",
      "GST Enabled Hotel Software",
      "Restaurant POS Software",
      "Restaurant Billing Software",
      "Restaurant KOT Software",
      "QR Code Menu Software",
      "Banquet Management Software",
      "Laundry Management Software",
      "Hotel Accounting Software",
      "Hotel Software in India",
      "Hotel Software in Siliguri",
      "Hotel Software in West Bengal",
    ],
  },
  {
    title: "JewSof",
    subtitle: "GST enabled Jewellery Software",
    image: h4,
    path: "/jewsof",
    category: "Jewellery",
    description:
      "JewSof is the most trusted, tested and proven software package for the jewelry industry. Its advance report utility will allow you to efficiently analyze your business, helping you increase your sales volume and profits. When it comes to the business crucial and important data, there is no reason to compromise.",
    seoText:
      "JewSof is a jewellery billing software for jewellery outlets and jewellery showrooms with GST billing, barcode, QR code, karigar, goldsmith, old gold, sales, purchase, stock, accounting and GSTR reports.",
    keywords: [
      "JewSof Jewellery Software",
      "Jewellery Billing Software",
      "Jewellery Management Software",
      "Jewellery ERP Software",
      "Jewellery Shop Software",
      "Jewellery Outlet Software",
      "Jewellery Retail Software",
      "Jewellery POS Software",
      "Gold Jewellery Software",
      "Silver Jewellery Software",
      "Diamond Jewellery Software",
      "Platinum Jewellery Software",
      "GST Jewellery Billing Software",
      "Jewellery Inventory Software",
      "Jewellery Stock Management Software",
      "Jewellery Accounting Software",
      "Jewellery Barcode Software",
      "Jewellery QR Code Software",
      "Karigar Management Software",
      "Goldsmith Management Software",
      "Jewellery Manufacturing Software",
      "Jewellery Order Management Software",
      "Old Gold Purchase Software",
      "Raw Gold Purchase Software",
      "Gold Stock Software",
      "Diamond Stock Software",
      "Jewellery Purchase Software",
      "Jewellery Sales Software",
      "Jewellery Software in India",
      "Jewellery Software in Siliguri",
      "Jewellery Software in West Bengal",
    ],
  },
  {
    title: "TeaSof",
    subtitle: "Tea Garden Software",
    image: h3,
    path: "/teasof",
    category: "Tea",
    description:
      "TeaSof, the software which specially developed for Tea Garden (Set Garden) Its cover worker wages (Weekly / fortnightly / Monthly along with Kamjari Analysis, periodical Garden activity), staff, sub-staff salary, Factory management, Accounting (Direct connectivity with wages, salary and stock controlling), Garden activity, and also cover complete inventory controlling. Software can be integrated with the automation of attendance system",
    seoText:
      "TeaSof is a tea garden management software and tea estate ERP for worker wages, Kamjari, Android attendance, staff salary, inventory, purchase, consumption, PF, bonus, ration and garden accounting.",
    keywords: [
      "TeaSof Tea Garden Software",
      "Tea Garden Management Software",
      "Tea Garden ERP Software",
      "Tea Estate ERP Software",
      "Tea Plantation Management Software",
      "Tea Garden Payroll Software",
      "Tea Estate Payroll Software",
      "Worker Wage Management Software",
      "Tea Garden Worker Wages",
      "Kamjari Management Software",
      "Daily Kamjari Software",
      "Tea Garden Attendance Software",
      "Android Attendance App for Tea Garden",
      "Tea Garden Worker Attendance App",
      "Tea Garden Employee Attendance App",
      "Plucking Weighment Software",
      "Green Leaf Weighment Software",
      "Weight Machine Integration Software",
      "Tea Garden Inventory Software",
      "Tea Estate Stock Management Software",
      "Tea Garden Purchase Management Software",
      "Indent Register Software",
      "Purchase Order Management Software",
      "Tea Garden Consumption Analysis",
      "Garden Accounting Software",
      "Tea Estate Accounting Software",
      "Tea Garden PF Register",
      "PF ECR Challan Software",
      "Tea Garden Bonus Register",
      "Tea Garden Ration Register",
      "Tea Garden ERP in India",
      "Darjeeling Tea Garden Software",
      "Assam Tea Garden Software",
    ],
  },
  {
    title: "TeaSale",
    subtitle: "Software for Tea Traders along with blending",
    image: h6,
    path: "/teasale",
    category: "Tea",
    description:
      "TeaSale, the software which specially developed for Tea Manufacturer Billing and Stock Controlling, Blending and Auction Sales. You can download one month demo version anytime. Its advance report utility will allow you to efficiently analyze your business, helping you increase your sales volume and profits.",
    seoText:
      "TeaSale is a tea trader and tea manufacturing software for tea billing, stock control, blending, auction sales, purchase, sales analysis and tea business accounting.",
    keywords: [
      "TeaSale Tea Trading Software",
      "Tea Trader Software",
      "Tea Trading Software",
      "Tea Manufacturing Software",
      "Tea Manufacturer Billing Software",
      "Tea Stock Management Software",
      "Tea Inventory Software",
      "Tea Blending Software",
      "Tea Auction Sales Software",
      "Tea Purchase Software",
      "Tea Sales Software",
      "Tea Billing Software",
      "Tea Accounting Software",
      "Tea Business Management Software",
      "Tea Trader Billing Software",
      "Tea Manufacturer Stock Software",
      "Tea Warehouse Stock Software",
      "Tea Purchase Sales Analysis Software",
      "Tea Supplier Management Software",
      "Tea Customer Ledger Software",
      "Tea GST Billing Software",
      "Tea Business Software in India",
      "Tea Trading Software in West Bengal",
      "Tea Software in Siliguri",
    ],
  },
  {
    title: "WardMaster",
    subtitle: "Complete Software solution for Hospital / Nursing",
    image: h2,
    path: "/Hospital",
    category: "Healthcare",
    description:
      "Wardmaster is powerful, flexible, easy to use and is designed and developed to deliver real conceivable benefits to hospitals and clinics. Hospital management System in a Hospital or a Nursing Home would require to very precise and must result into cost cutting and efficient management. Its cover Patient management(IPD and OPD), X-ray, scan and Diagonestic Reports, Pharmacy, Store Controlling(General and assets), PayRoll & Complete accounting system.",
    seoText:
      "WardMaster is a hospital management software and nursing home software for OPD, IPD, patient billing, diagnostic reports, pharmacy, store, payroll and accounting.",
    keywords: [
      "WardMaster Hospital Software",
      "Hospital Management Software",
      "Hospital ERP Software",
      "Nursing Home Software",
      "Clinic Management Software",
      "Healthcare Management Software",
      "Patient Management Software",
      "Patient Billing Software",
      "OPD Software",
      "IPD Software",
      "Hospital Billing Software",
      "Hospital Accounting Software",
      "Hospital Pharmacy Software",
      "Hospital Store Management Software",
      "Diagnostic Report Software",
      "X-Ray Report Software",
      "Scan Report Software",
      "Hospital Payroll Software",
      "Hospital Inventory Software",
      "Hospital Report Software",
      "Nursing Home Billing Software",
      "Healthcare Accounting Software",
      "Hospital Software in India",
      "Hospital Software in West Bengal",
      "Hospital Software in Siliguri",
    ],
  },
  {
    title: "Pharmacist",
    subtitle: "Software for Medicine Distributor and Retailers",
    image: h5,
    path: "/pharma",
    category: "Pharma",
    description:
      "An Integrated Accounting and Inventory Controlling System for Medicine Distributor's with wide variety of reports. And also its cover Batch Wise Stock Status, Near Expiry. Profit analysis, slow moving item statement, various analysis of sales and purchase and also cover full accounting analysis. Projecting sales analysis.",
    seoText:
      "Pharmacist is a pharmacy and medicine distributor software for medicine billing, batch-wise stock, near expiry, inventory, purchase, sales, profit analysis and accounting.",
    keywords: [
      "Pharmacist Pharma Software",
      "Pharmacy Billing Software",
      "Pharmacy Management Software",
      "Medicine Distributor Software",
      "Medicine Retail Software",
      "Medical Store Software",
      "Pharma Inventory Software",
      "Batch Wise Stock Software",
      "Medicine Batch Stock Software",
      "Near Expiry Stock Software",
      "Expiry Management Software",
      "Medicine Purchase Software",
      "Medicine Sales Software",
      "Pharma Accounting Software",
      "Pharmacy Accounting Software",
      "Drug Inventory Software",
      "Medicine Stock Management Software",
      "Slow Moving Medicine Report Software",
      "Pharma Profit Analysis Software",
      "Medicine Distributor Billing Software",
      "Medical Wholesale Software",
      "Pharma Software in India",
      "Pharma Software in West Bengal",
      "Pharmacy Software in Siliguri",
    ],
  },
  {
    title: "RestaurSof",
    subtitle: "GST Enabled Software for Restaurant and Pubs",
    image: h7,
    path: "/restaurant",
    category: "Restaurant",
    description:
      "RestaurSof - A restaurant management software is used to systematically manage restaurant operations. For a dine-in restaurant this includes order taking, kitchen order tickets (KOTs/BOTs), billing, reporting, inventory, recipe management, GST enabled reports and Financial Accounting. Web and Desktop version is available.",
    seoText:
      "RestaurSof is a restaurant management software and restaurant POS solution for KOT, BOT, order taking, billing, inventory, recipe management, GST reports and financial accounting.",
    keywords: [
      "RestaurSof Restaurant Software",
      "Restaurant POS Software",
      "Restaurant Billing Software",
      "Restaurant Management Software",
      "Restaurant ERP Software",
      "Restaurant KOT Software",
      "Kitchen Order Ticket Software",
      "BOT Software",
      "Restaurant Order Taking Software",
      "Restaurant Table Management Software",
      "Restaurant Inventory Software",
      "Restaurant Recipe Management Software",
      "Recipe Costing Software",
      "Food and Beverage POS Software",
      "F&B POS Software",
      "Restaurant GST Billing Software",
      "Restaurant Accounting Software",
      "Restaurant Report Software",
      "Restaurant Web Software",
      "Restaurant Desktop Software",
      "Pub Billing Software",
      "Bar and Restaurant Software",
      "Restaurant Software in India",
      "Restaurant Software in Siliguri",
      "Restaurant Software in West Bengal",
    ],
  },
  {
    title: "BakeryPro",
    subtitle: "GST Enabled Software for Bakery Management",
    image: h8,
    path: "/bakery",
    category: "Bakery",
    description:
      "BakeryPro is integrated software for Bakery Industries. His provides a multitude of features for bakeries and chains to maximize their operational efficiency and customer engagement! Everything from order management to delivery is fully supported by our system. The operations become more systematically Web Version available",
    seoText:
      "BakeryPro is a bakery management software for bakery billing, GST billing, order management, production, delivery, inventory, customer engagement and bakery chain operations.",
    keywords: [
      "BakeryPro Bakery Software",
      "Bakery Management Software",
      "Bakery Billing Software",
      "Bakery POS Software",
      "Bakery GST Billing Software",
      "Bakery Inventory Software",
      "Bakery Production Software",
      "Bakery Order Management Software",
      "Bakery Delivery Software",
      "Bakery Chain Software",
      "Cake Shop Billing Software",
      "Cake Order Management Software",
      "Bakery Web Application",
      "Bakery Customer Management Software",
      "Bakery Stock Management Software",
      "Bakery Purchase Software",
      "Bakery Sales Software",
      "Bakery Accounting Software",
      "Bakery Report Software",
      "Bakery Business Software",
      "Bakery Software in India",
      "Bakery Software in Siliguri",
      "Bakery Software in West Bengal",
    ],
  },
  {
    title: "PathoSof",
    subtitle: "Software for Pathology reports, Billing and Accounting",
    image: h9,
    path: "/pathology",
    category: "Healthcare",
    description:
      "With minimum or zero computer knowledge the receptionist can start patient registration and billing from Day one. The software will automatically calculate the total amount, apply the discount and calculate the balance amount thus avoiding any human errors. When you create a bill the lab report is automatically generated with the added tests.",
    seoText:
      "PathoSof is a pathology lab software for patient registration, pathology billing, diagnostic reports, lab test reports, discount, balance calculation and accounting.",
    keywords: [
      "PathoSof Pathology Software",
      "Pathology Lab Software",
      "Pathology Billing Software",
      "Lab Report Software",
      "Diagnostic Report Software",
      "Diagnostic Centre Software",
      "Patient Registration Software",
      "Patient Billing Software",
      "Pathology Accounting Software",
      "Medical Lab Software",
      "Laboratory Management Software",
      "Lab Billing Software",
      "Pathology Test Report Software",
      "Clinical Lab Software",
      "Lab Test Management Software",
      "Pathology Invoice Software",
      "Pathology Report Printing Software",
      "Diagnostic Billing Software",
      "Pathology Software in India",
      "Pathology Software in Siliguri",
      "Pathology Software in West Bengal",
    ],
  },
  {
    title: "TransportPro",
    subtitle: "Complete Web Application for Transport Solution",
    image: h10,
    path: "/transport",
    category: "Transport",
    description:
      "Transportation is one of the biggest sector now-a-days specially Goods/Courier Transportation Service. Transportation indirectly affects the development of a society. Get your transportation to new heights with our full featured application.",
    seoText:
      "TransportPro is a transport management software and web application for goods transport, courier service, LR booking, fleet, consignment, billing and reporting.",
    keywords: [
      "TransportPro Transport Software",
      "Transport Management Software",
      "Transport Billing Software",
      "Goods Transport Software",
      "Courier Management Software",
      "Courier Billing Software",
      "Logistics Management Software",
      "Logistics Billing Software",
      "Fleet Management Software",
      "Consignment Management Software",
      "LR Booking Software",
      "Lorry Receipt Software",
      "Transport Web Application",
      "Goods Booking Software",
      "Transport Accounting Software",
      "Transport Report Software",
      "Delivery Management Software",
      "Freight Billing Software",
      "Transport ERP Software",
      "Transport Software in India",
      "Transport Software in Siliguri",
      "Transport Software in West Bengal",
    ],
  },
  {
    title: "PayHR",
    subtitle: "Software for Payroll and HR",
    image: h11,
    path: "/paysof",
    category: "HR",
    description:
      "PayHR is the most trusted, tested and proven software package for the HR Department. It is a complete payroll management system with biometric attendance system. Its advance report utility will allow you to efficiently analyze your business, helping you increase your sales volume and profits.",
    seoText:
      "PayHR is a payroll and HR management software for salary processing, biometric attendance, employee management, payroll reports, HR reports and business workforce control.",
    keywords: [
      "PayHR Payroll Software",
      "Payroll Software",
      "HR Management Software",
      "Payroll Management System",
      "Salary Software",
      "Employee Management Software",
      "Biometric Attendance Software",
      "Attendance Management Software",
      "HR Payroll Software",
      "Payroll Accounting Software",
      "Salary Processing Software",
      "Employee Attendance Software",
      "HR Report Software",
      "Payroll Report Software",
      "Staff Salary Software",
      "Employee Salary Software",
      "PF Payroll Software",
      "ESI Payroll Software",
      "Professional Tax Software",
      "Leave Management Software",
      "Payroll Software in India",
      "Payroll Software in Siliguri",
      "Payroll Software in West Bengal",
    ],
  },
  {
    title: "NewsPro",
    subtitle: "News Papers Accounting with ABC circulation",
    image: h12,
    path: "/newssof",
    category: "Publication",
    description:
      "An Integrated complete systems for Newspapers, maintaining accounts for every-day newspapers circulations outstanding analysis, inventory controlling and all these advertisement modules reports, market selling reports and upcoming growths, ABC analysis and auditing system",
    seoText:
      "NewsPro is a newspaper accounting and publication management software for daily circulation, advertisement billing, outstanding analysis, inventory, market selling reports, ABC analysis and auditing.",
    keywords: [
      "NewsPro Newspaper Software",
      "Newspaper Accounting Software",
      "Publication Software",
      "Newspaper Management Software",
      "Newspaper Circulation Software",
      "Circulation Management Software",
      "ABC Circulation Software",
      "ABC Audit Software",
      "Advertisement Billing Software",
      "Newspaper Advertisement Software",
      "Publication Accounting Software",
      "Newspaper Billing Software",
      "Newspaper Outstanding Software",
      "Newspaper Inventory Software",
      "Market Selling Report Software",
      "Circulation Outstanding Software",
      "Newspaper Audit Software",
      "Publication Report Software",
      "Media Accounting Software",
      "Newspaper Software in India",
      "Publication Software in Siliguri",
      "Publication Software in West Bengal",
    ],
  },
];

const CATEGORY_TAGS = {
  Retail: ["POS Billing", "Inventory", "GST Reports"],
  Hospitality: ["PMS", "Restaurant POS", "Accounting"],
  Jewellery: ["Stock Control", "GST Billing", "Reports"],
  Tea: ["Garden Activity", "Payroll", "Factory Stock"],
  Healthcare: ["Patient Billing", "Reports", "Accounting"],
  Pharma: ["Batch Stock", "Expiry", "Purchase/Sales"],
  Restaurant: ["KOT/BOT", "Recipe", "GST Billing"],
  Bakery: ["Order Flow", "Delivery", "Web Ready"],
  Transport: ["LR Booking", "Fleet", "Web App"],
  HR: ["Payroll", "Attendance", "Employee"],
  Publication: ["Circulation", "Advertisement", "ABC Audit"],
};

const seoKeywords = Array.from(
  new Set(
    PRODUCTS.flatMap((item) => [
      item.title,
      item.subtitle,
      item.category,
      ...(item.keywords || []),
    ])
  )
);

const relatedSearchGroups = [
  ...PRODUCTS.map((item) => ({
    title: `${item.title} ${item.category} Software Keywords`,
    text: item.seoText,
    terms: item.keywords || [],
  })),
  {
    title: "Business Software by Location",
    text:
      "EBS Software Solution provides industry-specific business software for retail, hotel, restaurant, jewellery, tea, healthcare, pharma, transport, payroll and publication businesses in Siliguri, West Bengal and India.",
    terms: [
      "Business Software in India",
      "Business Software in Siliguri",
      "Business Software in West Bengal",
      "GST Billing Software in India",
      "Inventory Software in India",
      "Accounting Software in India",
      "ERP Software in India",
      "Software Company in Siliguri",
      "Software Company in West Bengal",
      "ERP Software Company in India",
      "Custom Software Development in Siliguri",
      "Business Automation Software in India",
      "Industry Specific Software in India",
    ],
  },
];

const Product = () => {
  const alText = "EBS Software Product Range";
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("All");

  const categories = useMemo(() => {
    return ["All", ...Array.from(new Set(PRODUCTS.map((item) => item.category)))];
  }, []);

  const filteredProducts = useMemo(() => {
    const keyword = searchText.trim().toLowerCase();

    return PRODUCTS.filter((item) => {
      const categoryMatch = category === "All" || item.category === category;

      const searchableText = [
        item.title,
        item.subtitle,
        item.category,
        item.description,
        item.seoText,
        ...(item.keywords || []),
      ]
        .join(" ")
        .toLowerCase();

      const searchMatch = keyword === "" || searchableText.includes(keyword);

      return categoryMatch && searchMatch;
    });
  }, [searchText, category]);

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath =
    typeof window !== "undefined" && window.location && window.location.pathname
      ? window.location.pathname
      : "/products";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Products | Business Software for Retail, Hotel, Jewellery, Tea, Healthcare & More";

  const seoDescription =
    "Explore EBS Software products for retail POS, hotel PMS, jewellery billing, tea garden ERP, tea trading, hospital, pharma, restaurant, bakery, pathology, transport, payroll and publication businesses.";

  const productItemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "EBS Software Product Range",
    url: pageUrl,
    description: seoDescription,
    itemListElement: PRODUCTS.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${siteUrl}${item.path}`,
      item: {
        "@type": "SoftwareApplication",
        name: item.title,
        alternateName: item.subtitle,
        applicationCategory: "BusinessApplication",
        operatingSystem: "Windows, Web",
        url: `${siteUrl}${item.path}`,
        image: String(item.image || "").startsWith("http")
          ? item.image
          : `${siteUrl}${item.image}`,
        description: item.seoText || item.description,
        keywords: [
          item.title,
          item.subtitle,
          item.category,
          ...(CATEGORY_TAGS[item.category] || []),
          ...(item.keywords || []),
        ].join(", "),
        publisher: {
          "@type": "Organization",
          name: "EBS Software Solution",
          url: siteUrl,
        },
      },
    })),
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "EBS Software Solution",
    url: siteUrl,
    description:
      "Business software provider for retail, hotel, jewellery, tea, healthcare, pharma, restaurant, bakery, pathology, transport, HR payroll and publication industries.",
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  const enquiryLink = (item) => {
    const params = new URLSearchParams({
      product: item.title,
      category: item.category,
      subtitle: item.subtitle,
    });

    return `/product-enquiry?${params.toString()}`;
  };

  const clearFilters = () => {
    setSearchText("");
    setCategory("All");
  };

  const getTags = (item) => {
    return CATEGORY_TAGS[item.category] || ["GST Ready", "Reports", "Accounting"];
  };

  return (
    <main className="product-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([productItemListSchema, organizationSchema])}
        </script>
      </Helmet>

      <section className="product-hero">
        <img
          className="product-hero-image"
          src={web5}
          alt={alText}
          onError={handleImageError}
        />
        <div className="product-hero-overlay"></div>

        <Container className="product-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={8}>
              <div className="product-hero-content">
                <div className="product-kicker">EBS Software Products</div>
                <h1>Industry-ready business software solutions</h1>
                <p>
                  Explore professional software products for retail, hotel,
                  jewellery, tea, healthcare, pharma, restaurant, bakery,
                  pathology, transport, payroll and publication businesses.
                  Our products are built for practical operations, GST billing,
                  inventory control, accounting and management reporting.
                </p>

                <div className="product-hero-highlights">
                  <div>
                    <strong>{PRODUCTS.length}+</strong>
                    <span>Software Products</span>
                  </div>
                  <div>
                    <strong>{categories.length - 1}+</strong>
                    <span>Business Categories</span>
                  </div>
                  <div>
                    <strong>GST</strong>
                    <span>Ready Solutions</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div className="product-hero-card">
                <span>Product Range</span>
                <strong>Complete ERP-ready solutions</strong>
                <p>
                  Designed for business automation with billing, stock,
                  accounting, reports and industry-wise operational control.
                </p>

                <div className="product-hero-card-list">
                  <div>✓ Desktop & Web Application Options</div>
                  <div>✓ Inventory and Accounting Integrated</div>
                  <div>✓ Industry-specific Workflow</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="product-filter-section">
        <Container>
          <div className="product-filter-card">
            <Row className="g-3 align-items-end">
              <Col lg={7}>
                <label className="product-filter-label" htmlFor="productSearch">
                  Search Products
                </label>
                <input
                  id="productSearch"
                  className="product-search-input"
                  type="text"
                  value={searchText}
                  onChange={(event) => setSearchText(event.target.value)}
                  placeholder="Search by product name, industry, features..."
                />
              </Col>

              <Col lg={3} md={7}>
                <label className="product-filter-label" htmlFor="productCategory">
                  Category
                </label>
                <select
                  id="productCategory"
                  className="product-category-select"
                  value={category}
                  onChange={(event) => setCategory(event.target.value)}
                >
                  {categories.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Col>

              <Col lg={2} md={5}>
                <button
                  type="button"
                  className="product-clear-btn"
                  onClick={clearFilters}
                >
                  Clear Filter
                </button>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="product-list-section">
        <Container>
          <div className="product-result-header">
            <div>
              <span>Products</span>
              <h2>Our software product range</h2>
              <p>
                Choose the right product for your business operation and request
                a demo or detailed consultation.
              </p>
            </div>

            <strong>
              {filteredProducts.length}{" "}
              {filteredProducts.length === 1 ? "Product" : "Products"}
            </strong>
          </div>

          {filteredProducts.length > 0 ? (
            <Row className="g-4">
              {filteredProducts.map((item) => (
                <Col lg={4} md={6} key={item.title}>
                  <article className="product-card">
                    <div className="product-card-image-wrap">
                      <img
                        src={item.image}
                        alt={`${item.title} ${item.category} software`}
                        onError={handleImageError}
                      />
                      <span className="product-category-badge">
                        {item.category}
                      </span>
                    </div>

                    <div className="product-card-body">
                      <div className="product-card-top">
                        <span className="product-card-label">
                          {item.category} Solution
                        </span>
                        <h3>{item.title}</h3>
                        <h4>{item.subtitle}</h4>
                      </div>

                      <div className="product-card-tags">
                        {getTags(item).map((tag) => (
                          <span key={`${item.title}-${tag}`}>{tag}</span>
                        ))}
                      </div>

                      <p className="product-card-description">
                        {item.description}
                      </p>

                      <div className="product-enquiry-action-row">
                        <Link to={item.path} className="product-more-btn">
                          More Details
                        </Link>

                        <Link to={enquiryLink(item)} className="product-enquiry-btn">
                          Product Enquiry
                        </Link>
                      </div>
                    </div>
                  </article>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="product-empty-state">
              <h3>No product found</h3>
              <p>
                Try changing the search text or category filter to view product
                details.
              </p>
              <button
                type="button"
                className="product-empty-btn"
                onClick={clearFilters}
              >
                Reset Search
              </button>
            </div>
          )}
        </Container>
      </section>

      <section className="product-corporate-keywords-section">
        <Container>
          <div className="product-corporate-keywords-head">
            <div className="product-section-label">Related Solutions</div>
            <h2>Product-wise software keywords for all EBS business solutions</h2>
            <p>
              These product-wise search terms describe all EBS Software products
              including retail, hotel, jewellery, tea, healthcare, pharma,
              restaurant, bakery, pathology, transport, payroll and publication
              software solutions.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="product-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="product-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Product;